import slice from './releaseNotes.slice'

export const selectSlice = (state) => state[slice.name]

export const selectReleaseNotes = (state) => selectSlice(state).allReleaseNotes

export const selectShouldFetchReleaseNotes = (state) =>
	selectSlice(state).shouldFetchReleaseNotes

export const selectReleaseNoteModal = (state) =>
	selectSlice(state).releaseNoteModal

export const selectReleaseNoteToBeDeleted = (state) =>
	selectSlice(state).releaseNoteToBeDeleted

export const selectShouldDisableAddButton = (state) =>
	selectSlice(state).shouldDisableAddButton

export const selectIsReleaseNoteDeleted = (state) =>
	selectSlice(state).isReleaseNoteDeleted
